import { render, staticRenderFns } from "./BackCard.vue?vue&type=template&id=ff1050f6&scoped=true&"
import script from "./BackCard.vue?vue&type=script&lang=js&"
export * from "./BackCard.vue?vue&type=script&lang=js&"
import style0 from "./BackCard.vue?vue&type=style&index=0&id=ff1050f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1050f6",
  null
  
)

export default component.exports